import React from 'react'
import { useOnboardingStack } from '../LearnPage/useOnboardingStack'
import { OnboardingCard } from './OnboardingCard'
import { stackWrapperStyle } from './onboardingCardStyles'

export function OnboardingStack() {
  const { allCards, visibleCards, toggleShowAllStepsView, isLoadingSteps } = useOnboardingStack()
  if (!visibleCards || visibleCards.length === 0) {
    return null
  }
  if (isLoadingSteps || !allCards || allCards.length === 0) {
    return null
  }

  const handleToggleView = () => {
    toggleShowAllStepsView()
  }

  const cardsForStackView = visibleCards.slice(0, Math.min(visibleCards.length, 4))
  const totalForStack = cardsForStackView.length
  return (
    <>
      <div className={stackWrapperStyle}>
        {cardsForStackView.map((card, idx) => (
          <OnboardingCard
            key={card.apiType || card.id}
            title={card.title}
            description={card.description}
            apiType={card.apiType}
            status={card.status}
            completed={card.completed}
            stackOffset={card.id}
            isTop={idx === 0}
            onSeeAll={idx === 0 ? handleToggleView : undefined}
            total={totalForStack}
            actionButtonText={card.actionButtonText}
            skipButtonText={card.skipButtonText}
            secondaryActionButtonText={card.secondaryActionButtonText}
            isRequired={card.isRequired}
          />
        ))}
      </div>
    </>
  )
}
